module.exports = __webpack_public_path__ + "img/6-3.b93c8649.jpg";